// extracted by mini-css-extract-plugin
module.exports = {"customer":"CustomerCell_customer__3mwyJ","avatar":"CustomerCell_avatar__y5LR-","nameWrapper":"CustomerCell_nameWrapper__ZfkHW","customerName":"CustomerCell_customerName__3Movr"};